const PrintIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 7V3H6V7H18ZM18 15V21H6V15H18ZM19 12C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10C18.4477 10 18 10.4477 18 11C18 11.5523 18.4477 12 19 12ZM16 7H8V5H16V7ZM4 9V17H20V9H4Z"
            fill="#EF8658"
        />
    </svg>
)

export default PrintIcon
